import { createTheme } from "@mui/material/styles";
import { alpha, getContrastRatio } from "@mui/material/styles";

const mainColor = "#f97316";

// Calculate lighter and darker shades of the main color (kept for backward compat)
const lighterMainColor = alpha(mainColor, 0.5);
const darkerMainColor = alpha(mainColor, 0.8);

// Calculate contrast text color based on contrast ratio
const contrastTextColor =
  getContrastRatio(mainColor, "#fff") > 4.5 ? "#fff" : "#111";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f97316",
      light: "#ffedd5",
      dark: "#c2410c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f59e0b",
      light: "#fde68a",
      dark: "#b45309",
      contrastText: "#ffffff",
    },
    neutral: {
      main: "#667085",
      light: "#f3f4f6",
      dark: "#1f2937",
      contrastText: "#ffffff",
    },
    // Keep existing custom palette entry for backward compat.
    custom: {
      main: mainColor,
      light: lighterMainColor,
      dark: darkerMainColor,
      contrastText: contrastTextColor,
      circularProgress: "#fff",
    },
  },
  typography: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    h1: { fontSize: 32, fontWeight: 700, lineHeight: 1.25 },
    h2: { fontSize: 24, fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: 20, fontWeight: 600 },
    h4: { fontSize: 18, fontWeight: 600 },
    body1: { fontSize: 16 },
    body2: { fontSize: 14 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 9999,
          fontWeight: 600,
          minHeight: 44,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f97316",
              borderWidth: 2,
              boxShadow: "0 0 0 3px rgba(249,115,22,0.15)",
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#f97316",
          },
        },
      },
    },
  },
});

export default theme;
